module.exports = __webpack_public_path__ + "static/media/join.8c843675.mp3";